export default __webpack_public_path__ + "static/media/border-minus.194a8a3e.svg";